import { Td, Tooltip, Tr } from "@chakra-ui/react";
import { AlertErrorAlert } from "components/Alerts/AlertErrorAlert";
import MenuRUD from "components/Menu/MenuRUD";
import environment from "constants/apiConst";
import ConfigurationCRUDContext from "context/ConfigurationCRUDContext";
import { ConfigIconStatus } from "pages/Configuration/tables/components/LoadingConfig";
import React, { useContext, useState } from "react";
import { BsCheckCircleFill } from "react-icons/bs";
import { useSelector } from "react-redux";
import {
  __ACTIVAR,
  __DESACTIVAR
} from "request/configuration/__Activar_Desactivar";
import { __ShowBusinessUnit } from "request/configuration/__BusinessUnits";
import styled from "styled-components";
import { IconGeneric } from "styled/Icons.styled";

const TdState = styled(Td)`
  color: ${(props) => (props.text === 1 ? "#58D68D" : "#F1948A")};
`;

const TbodyBusinessUnits = ({ data }) => {
  const token = useSelector((state) => state.auth.dataUser.token);
  const { setUpdate, update, setLoading } = useContext(
    ConfigurationCRUDContext
  );
  const [openAlert] = AlertErrorAlert();
  const [loadingIcons, setLoadingIcons] = useState(false);

  const desactivarAndActivar = async (result) => {
    setLoading(true);
    try {
      const resultado =
        result === 1
          ? await __DESACTIVAR(
            token,
            environment.BUSINESS_UNITS_DESACTIVE,
            data.id
          )
          : await __ACTIVAR(token, environment.BUSINESS_UNITS_ACTIVE, data.id);
      if (resultado.data.status.code !== 200) {
        openAlert(resultado.data.status.message, "error");
      } else {
        setUpdate(!update);
      }
    } catch (error) {
      console.log(error);
    } finally {
      setLoading(false);
    }
  };

  const handleState = async () => {
    if (loadingIcons) return;

    setLoadingIcons(true);
    try {
      const res = await __ShowBusinessUnit(token, data.id);
      const result = res.data.status.data.status_businessUnit;
      desactivarAndActivar(result);
    } catch (error) {
      console.log(error);
    } finally {
      setLoadingIcons(false);
    }
  };

  return (
    <Tr>
      <Td className="text-center">{data?.code_businessUnit}</Td>
      <Td className="text-center">{data?.name_businessUnit}</Td>
      <Tooltip
        placement="top"
        hasArrow
        label={data.status_businessUnit === 1 ? "Desactivar" : "Activar"}
      >
        <TdState
          onClick={handleState}
          className="text-center"
          isNumeric
          text={data.status_businessUnit}
        >
          <ConfigIconStatus
            loading={loadingIcons}
            status={data?.status_businessUnit}
          />
        </TdState>
      </Tooltip>
      <Td className="text-center" isNumeric>
        <MenuRUD data={data} />
      </Td>
    </Tr>
  );
};

export default TbodyBusinessUnits;
